import React, {useEffect, useState} from "react";
import { Radio as AntRadio } from 'antd';
import {convertToOptions} from "../../../utils/arrayObjectHelper";

const componentClass = 'fieldType__radio';

const Radio = ({ onChange, options, shouldConvertOptions, value }) => {
  const optionsToUse = shouldConvertOptions ? convertToOptions(options) : options;

  const [currentValue, setCurrentValue] = useState(value);
  useEffect(() => { setCurrentValue(value) }, [value]);

  const renderRadios = () => {
    return (optionsToUse || []).map(o => {
      const optionValue = o.value || o.label;
      return <AntRadio value={optionValue}>
        { o.label || o.value }
      </AntRadio>
    })
  };

  const onValueChange = v => {
    setCurrentValue(v);
    onChange(v);
  };

  return <AntRadio.Group
      className={componentClass}
      value={currentValue}
      onChange={(e) => onValueChange(e.target.value)}
  >
    { renderRadios() }
  </AntRadio.Group>;
};

export default Radio;
